import AnswerInformation from './answerInformation'

export { AnswerInformation }
